// data from: https://countrycode.org/

export const COUNTRY_DIALING_CODES = [
	{
		"countryName": "Afghanistan",
		"isoCode": "AF",
		"dialingCode": "93",
	},
	{
		"countryName": "Albania",
		"isoCode": "AL",
		"dialingCode": "355",
	},
	{
		"countryName": "Algeria",
		"isoCode": "DZ",
		"dialingCode": "213",
	},
	{
		"countryName": "American Samoa",
		"isoCode": "AS",
		"dialingCode": "1684",
	},
	{
		"countryName": "Andorra",
		"isoCode": "AD",
		"dialingCode": "376",
	},
	{
		"countryName": "Angola",
		"isoCode": "AO",
		"dialingCode": "244",
	},
	{
		"countryName": "Anguilla",
		"isoCode": "AI",
		"dialingCode": "1",
	},
	{
		"countryName": "Antarctica",
		"isoCode": "AQ",
		"dialingCode": "672",
	},
	{
		"countryName": "Antigua and Barbuda",
		"isoCode": "AG",
		"dialingCode": "1",
	},
	{
		"countryName": "Argentina",
		"isoCode": "AR",
		"dialingCode": "54",
	},
	{
		"countryName": "Armenia",
		"isoCode": "AM",
		"dialingCode": "374",
	},
	{
		"countryName": "Aruba",
		"isoCode": "AW",
		"dialingCode": "297",
	},
	{
		"countryName": "Australia",
		"isoCode": "AU",
		"dialingCode": "61",
	},
	{
		"countryName": "Austria",
		"isoCode": "AT",
		"dialingCode": "43",
	},
	{
		"countryName": "Azerbaijan",
		"isoCode": "AZ",
		"dialingCode": "994",
	},
	{
		"countryName": "Bahamas",
		"isoCode": "BS",
		"dialingCode": "1",
	},
	{
		"countryName": "Bahrain",
		"isoCode": "BH",
		"dialingCode": "973",
	},
	{
		"countryName": "Bangladesh",
		"isoCode": "BD",
		"dialingCode": "880",
	},
	{
		"countryName": "Barbados",
		"isoCode": "BB",
		"dialingCode": "1",
	},
	{
		"countryName": "Belarus",
		"isoCode": "BY",
		"dialingCode": "375",
	},
	{
		"countryName": "Belgium",
		"isoCode": "BE",
		"dialingCode": "32",
	},
	{
		"countryName": "Belize",
		"isoCode": "BZ",
		"dialingCode": "501",
	},
	{
		"countryName": "Benin",
		"isoCode": "BJ",
		"dialingCode": "229",
	},
	{
		"countryName": "Bermuda",
		"isoCode": "BM",
		"dialingCode": "1",
	},
	{
		"countryName": "Bhutan",
		"isoCode": "BT",
		"dialingCode": "975",
	},
	{
		"countryName": "Bolivia",
		"isoCode": "BO",
		"dialingCode": "591",
	},
	{
		"countryName": "Bosnia and Herzegovina",
		"isoCode": "BA",
		"dialingCode": "387",
	},
	{
		"countryName": "Botswana",
		"isoCode": "BW",
		"dialingCode": "267",
	},
	{
		"countryName": "Brazil",
		"isoCode": "BR",
		"dialingCode": "55",
	},
	{
		"countryName": "British Indian Ocean Territory",
		"isoCode": "IO",
		"dialingCode": "246",
	},
	{
		"countryName": "British Virgin Islands",
		"isoCode": "VG",
		"dialingCode": "1",
	},
	{
		"countryName": "Brunei",
		"isoCode": "BN",
		"dialingCode": "673",
	},
	{
		"countryName": "Bulgaria",
		"isoCode": "BG",
		"dialingCode": "359",
	},
	{
		"countryName": "Burkina Faso",
		"isoCode": "BF",
		"dialingCode": "226",
	},
	{
		"countryName": "Myanmar",
		"isoCode": "MM",
		"dialingCode": "95",
	},
	{
		"countryName": "Burundi",
		"isoCode": "BI",
		"dialingCode": "257",
	},
	{
		"countryName": "Cambodia",
		"isoCode": "KH",
		"dialingCode": "855",
	},
	{
		"countryName": "Cameroon",
		"isoCode": "CM",
		"dialingCode": "237",
	},
	{
		"countryName": "Canada",
		"isoCode": "CA",
		"dialingCode": "1",
	},
	{
		"countryName": "Cape Verde",
		"isoCode": "CV",
		"dialingCode": "238",
	},
	{
		"countryName": "Cayman Islands",
		"isoCode": "KY",
		"dialingCode": "1",
	},
	{
		"countryName": "Central African Republic",
		"isoCode": "CF",
		"dialingCode": "236",
	},
	{
		"countryName": "Chad",
		"isoCode": "TD",
		"dialingCode": "235",
	},
	{
		"countryName": "Chile",
		"isoCode": "CL",
		"dialingCode": "56",
	},
	{
		"countryName": "China",
		"isoCode": "CN",
		"dialingCode": "86",
	},
	{
		"countryName": "Christmas Island",
		"isoCode": "CX",
		"dialingCode": "61",
	},
	{
		"countryName": "Cocos Islands",
		"isoCode": "CC",
		"dialingCode": "61",
	},
	{
		"countryName": "Colombia",
		"isoCode": "CO",
		"dialingCode": "57",
	},
	{
		"countryName": "Comoros",
		"isoCode": "KM",
		"dialingCode": "269",
	},
	{
		"countryName": "Republic of the Congo",
		"isoCode": "CG",
		"dialingCode": "242",
	},
	{
		"countryName": "Democratic Republic of the Congo",
		"isoCode": "CD",
		"dialingCode": "243",
	},
	{
		"countryName": "Cook Islands",
		"isoCode": "CK",
		"dialingCode": "682",
	},
	{
		"countryName": "Costa Rica",
		"isoCode": "CR",
		"dialingCode": "506",
	},
	{
		"countryName": "Croatia",
		"isoCode": "HR",
		"dialingCode": "385",
	},
	{
		"countryName": "Cuba",
		"isoCode": "CU",
		"dialingCode": "53",
	},
	{
		"countryName": "Curacao",
		"isoCode": "CW",
		"dialingCode": "599",
	},
	{
		"countryName": "Cyprus",
		"isoCode": "CY",
		"dialingCode": "357",
	},
	{
		"countryName": "Czech Republic",
		"isoCode": "CZ",
		"dialingCode": "420",
	},
	{
		"countryName": "Denmark",
		"isoCode": "DK",
		"dialingCode": "45",
	},
	{
		"countryName": "Djibouti",
		"isoCode": "DJ",
		"dialingCode": "253",
	},
	{
		"countryName": "Dominica",
		"isoCode": "DM",
		"dialingCode": "1",
	},
	{
		"countryName": "Dominican Republic",
		"isoCode": "DO",
		"dialingCode": "1",
	},
	{
		"countryName": "East Timor",
		"isoCode": "TL",
		"dialingCode": "670",
	},
	{
		"countryName": "Ecuador",
		"isoCode": "EC",
		"dialingCode": "593",
	},
	{
		"countryName": "Egypt",
		"isoCode": "EG",
		"dialingCode": "20",
	},
	{
		"countryName": "El Salvador",
		"isoCode": "SV",
		"dialingCode": "503",
	},
	{
		"countryName": "Equatorial Guinea",
		"isoCode": "GQ",
		"dialingCode": "240",
	},
	{
		"countryName": "Eritrea",
		"isoCode": "ER",
		"dialingCode": "291",
	},
	{
		"countryName": "Estonia",
		"isoCode": "EE",
		"dialingCode": "372",
	},
	{
		"countryName": "Ethiopia",
		"isoCode": "ET",
		"dialingCode": "251",
	},
	{
		"countryName": "Falkland Islands",
		"isoCode": "FK",
		"dialingCode": "500",
	},
	{
		"countryName": "Faroe Islands",
		"isoCode": "FO",
		"dialingCode": "298",
	},
	{
		"countryName": "Fiji",
		"isoCode": "FJ",
		"dialingCode": "679",
	},
	{
		"countryName": "Finland",
		"isoCode": "FI",
		"dialingCode": "358",
	},
	{
		"countryName": "France",
		"isoCode": "FR",
		"dialingCode": "33",
	},
	{
		"countryName": "French Polynesia",
		"isoCode": "PF",
		"dialingCode": "689",
	},
	{
		"countryName": "Gabon",
		"isoCode": "GA",
		"dialingCode": "241",
	},
	{
		"countryName": "Gambia",
		"isoCode": "GM",
		"dialingCode": "220",
	},
	{
		"countryName": "Georgia",
		"isoCode": "GE",
		"dialingCode": "995",
	},
	{
		"countryName": "Germany",
		"isoCode": "DE",
		"dialingCode": "49",
	},
	{
		"countryName": "Ghana",
		"isoCode": "GH",
		"dialingCode": "233",
	},
	{
		"countryName": "Gibraltar",
		"isoCode": "GI",
		"dialingCode": "350",
	},
	{
		"countryName": "Greece",
		"isoCode": "GR",
		"dialingCode": "30",
	},
	{
		"countryName": "Greenland",
		"isoCode": "GL",
		"dialingCode": "299",
	},
	{
		"countryName": "Grenada",
		"isoCode": "GD",
		"dialingCode": "1",
	},
	{
		"countryName": "Guam",
		"isoCode": "GU",
		"dialingCode": "1",
	},
	{
		"countryName": "Guatemala",
		"isoCode": "GT",
		"dialingCode": "502",
	},
	{
		"countryName": "Guernsey",
		"isoCode": "GG",
		"dialingCode": "44-1481",
	},
	{
		"countryName": "Guinea",
		"isoCode": "GN",
		"dialingCode": "224",
	},
	{
		"countryName": "Guinea-Bissau",
		"isoCode": "GW",
		"dialingCode": "245",
	},
	{
		"countryName": "Guyana",
		"isoCode": "GY",
		"dialingCode": "592",
	},
	{
		"countryName": "Haiti",
		"isoCode": "HT",
		"dialingCode": "509",
	},
	{
		"countryName": "Honduras",
		"isoCode": "HN",
		"dialingCode": "504",
	},
	{
		"countryName": "Hong Kong",
		"isoCode": "HK",
		"dialingCode": "852",
	},
	{
		"countryName": "Hungary",
		"isoCode": "HU",
		"dialingCode": "36",
	},
	{
		"countryName": "Iceland",
		"isoCode": "IS",
		"dialingCode": "354",
	},
	{
		"countryName": "India",
		"isoCode": "IN",
		"dialingCode": "91",
	},
	{
		"countryName": "Indonesia",
		"isoCode": "ID",
		"dialingCode": "62",
	},
	{
		"countryName": "Iran",
		"isoCode": "IR",
		"dialingCode": "98",
	},
	{
		"countryName": "Iraq",
		"isoCode": "IQ",
		"dialingCode": "964",
	},
	{
		"countryName": "Ireland",
		"isoCode": "IE",
		"dialingCode": "353",
	},
	{
		"countryName": "Isle of Man",
		"isoCode": "IM",
		"dialingCode": "44-1624",
	},
	{
		"countryName": "Israel",
		"isoCode": "IL",
		"dialingCode": "972",
	},
	{
		"countryName": "Italy",
		"isoCode": "IT",
		"dialingCode": "39",
	},
	{
		"countryName": "Ivory Coast",
		"isoCode": "CI",
		"dialingCode": "225",
	},
	{
		"countryName": "Jamaica",
		"isoCode": "JM",
		"dialingCode": "1",
	},
	{
		"countryName": "Japan",
		"isoCode": "JP",
		"dialingCode": "81",
	},
	{
		"countryName": "Jersey",
		"isoCode": "JE",
		"dialingCode": "44-1534",
	},
	{
		"countryName": "Jordan",
		"isoCode": "JO",
		"dialingCode": "962",
	},
	{
		"countryName": "Kazakhstan",
		"isoCode": "KZ",
		"dialingCode": "7",
	},
	{
		"countryName": "Kenya",
		"isoCode": "KE",
		"dialingCode": "254",
	},
	{
		"countryName": "Kiribati",
		"isoCode": "KI",
		"dialingCode": "686",
	},
	{
		"countryName": "Kosovo",
		"isoCode": "XK",
		"dialingCode": "383",
	},
	{
		"countryName": "Kuwait",
		"isoCode": "KW",
		"dialingCode": "965",
	},
	{
		"countryName": "Kyrgyzstan",
		"isoCode": "KG",
		"dialingCode": "996",
	},
	{
		"countryName": "Laos",
		"isoCode": "LA",
		"dialingCode": "856",
	},
	{
		"countryName": "Latvia",
		"isoCode": "LV",
		"dialingCode": "371",
	},
	{
		"countryName": "Lebanon",
		"isoCode": "LB",
		"dialingCode": "961",
	},
	{
		"countryName": "Lesotho",
		"isoCode": "LS",
		"dialingCode": "266",
	},
	{
		"countryName": "Liberia",
		"isoCode": "LR",
		"dialingCode": "231",
	},
	{
		"countryName": "Libya",
		"isoCode": "LY",
		"dialingCode": "218",
	},
	{
		"countryName": "Liechtenstein",
		"isoCode": "LI",
		"dialingCode": "423",
	},
	{
		"countryName": "Lithuania",
		"isoCode": "LT",
		"dialingCode": "370",
	},
	{
		"countryName": "Luxembourg",
		"isoCode": "LU",
		"dialingCode": "352",
	},
	{
		"countryName": "Macau",
		"isoCode": "MO",
		"dialingCode": "853",
	},
	{
		"countryName": "Macedonia",
		"isoCode": "MK",
		"dialingCode": "389",
	},
	{
		"countryName": "Madagascar",
		"isoCode": "MG",
		"dialingCode": "261",
	},
	{
		"countryName": "Malawi",
		"isoCode": "MW",
		"dialingCode": "265",
	},
	{
		"countryName": "Malaysia",
		"isoCode": "MY",
		"dialingCode": "60",
	},
	{
		"countryName": "Maldives",
		"isoCode": "MV",
		"dialingCode": "960",
	},
	{
		"countryName": "Mali",
		"isoCode": "ML",
		"dialingCode": "223",
	},
	{
		"countryName": "Malta",
		"isoCode": "MT",
		"dialingCode": "356",
	},
	{
		"countryName": "Marshall Islands",
		"isoCode": "MH",
		"dialingCode": "692",
	},
	{
		"countryName": "Mauritania",
		"isoCode": "MR",
		"dialingCode": "222",
	},
	{
		"countryName": "Mauritius",
		"isoCode": "MU",
		"dialingCode": "230",
	},
	{
		"countryName": "Mayotte",
		"isoCode": "YT",
		"dialingCode": "262",
	},
	{
		"countryName": "Mexico",
		"isoCode": "MX",
		"dialingCode": "52",
	},
	{
		"countryName": "Micronesia",
		"isoCode": "FM",
		"dialingCode": "691",
	},
	{
		"countryName": "Moldova",
		"isoCode": "MD",
		"dialingCode": "373",
	},
	{
		"countryName": "Monaco",
		"isoCode": "MC",
		"dialingCode": "377",
	},
	{
		"countryName": "Mongolia",
		"isoCode": "MN",
		"dialingCode": "976",
	},
	{
		"countryName": "Montenegro",
		"isoCode": "ME",
		"dialingCode": "382",
	},
	{
		"countryName": "Montserrat",
		"isoCode": "MS",
		"dialingCode": "1",
	},
	{
		"countryName": "Morocco",
		"isoCode": "MA",
		"dialingCode": "212",
	},
	{
		"countryName": "Mozambique",
		"isoCode": "MZ",
		"dialingCode": "258",
	},
	{
		"countryName": "Namibia",
		"isoCode": "NA",
		"dialingCode": "264",
	},
	{
		"countryName": "Nauru",
		"isoCode": "NR",
		"dialingCode": "674",
	},
	{
		"countryName": "Nepal",
		"isoCode": "NP",
		"dialingCode": "977",
	},
	{
		"countryName": "Netherlands",
		"isoCode": "NL",
		"dialingCode": "31",
	},
	{
		"countryName": "Netherlands Antilles",
		"isoCode": "AN",
		"dialingCode": "599",
	},
	{
		"countryName": "New Caledonia",
		"isoCode": "NC",
		"dialingCode": "687",
	},
	{
		"countryName": "New Zealand",
		"isoCode": "NZ",
		"dialingCode": "64",
	},
	{
		"countryName": "Nicaragua",
		"isoCode": "NI",
		"dialingCode": "505",
	},
	{
		"countryName": "Niger",
		"isoCode": "NE",
		"dialingCode": "227",
	},
	{
		"countryName": "Nigeria",
		"isoCode": "NG",
		"dialingCode": "234",
	},
	{
		"countryName": "Niue",
		"isoCode": "NU",
		"dialingCode": "683",
	},
	{
		"countryName": "Northern Mariana Islands",
		"isoCode": "MP",
		"dialingCode": "1",
	},
	{
		"countryName": "North Korea",
		"isoCode": "KP",
		"dialingCode": "850",
	},
	{
		"countryName": "Norway",
		"isoCode": "NO",
		"dialingCode": "47",
	},
	{
		"countryName": "Oman",
		"isoCode": "OM",
		"dialingCode": "968",
	},
	{
		"countryName": "Pakistan",
		"isoCode": "PK",
		"dialingCode": "92",
	},
	{
		"countryName": "Palau",
		"isoCode": "PW",
		"dialingCode": "680",
	},
	{
		"countryName": "Palestine",
		"isoCode": "PS",
		"dialingCode": "970",
	},
	{
		"countryName": "Panama",
		"isoCode": "PA",
		"dialingCode": "507",
	},
	{
		"countryName": "Papua New Guinea",
		"isoCode": "PG",
		"dialingCode": "675",
	},
	{
		"countryName": "Paraguay",
		"isoCode": "PY",
		"dialingCode": "595",
	},
	{
		"countryName": "Peru",
		"isoCode": "PE",
		"dialingCode": "51",
	},
	{
		"countryName": "Philippines",
		"isoCode": "PH",
		"dialingCode": "63",
	},
	{
		"countryName": "Pitcairn",
		"isoCode": "PN",
		"dialingCode": "64",
	},
	{
		"countryName": "Poland",
		"isoCode": "PL",
		"dialingCode": "48",
	},
	{
		"countryName": "Portugal",
		"isoCode": "PT",
		"dialingCode": "351",
	},
	{
		"countryName": "Puerto Rico",
		"isoCode": "PR",
		"dialingCode": "1",
	},
	{
		"countryName": "Qatar",
		"isoCode": "QA",
		"dialingCode": "974",
	},
	{
		"countryName": "Reunion",
		"isoCode": "RE",
		"dialingCode": "262",
	},
	{
		"countryName": "Romania",
		"isoCode": "RO",
		"dialingCode": "40",
	},
	{
		"countryName": "Russia",
		"isoCode": "RU",
		"dialingCode": "7",
	},
	{
		"countryName": "Rwanda",
		"isoCode": "RW",
		"dialingCode": "250",
	},
	{
		"countryName": "Saint Barthelemy",
		"isoCode": "BL",
		"dialingCode": "590",
	},
	{
		"countryName": "Samoa",
		"isoCode": "WS",
		"dialingCode": "685",
	},
	{
		"countryName": "San Marino",
		"isoCode": "SM",
		"dialingCode": "378",
	},
	{
		"countryName": "Sao Tome and Principe",
		"isoCode": "ST",
		"dialingCode": "239",
	},
	{
		"countryName": "Saudi Arabia",
		"isoCode": "SA",
		"dialingCode": "966",
	},
	{
		"countryName": "Senegal",
		"isoCode": "SN",
		"dialingCode": "221",
	},
	{
		"countryName": "Serbia",
		"isoCode": "RS",
		"dialingCode": "381",
	},
	{
		"countryName": "Seychelles",
		"isoCode": "SC",
		"dialingCode": "248",
	},
	{
		"countryName": "Sierra Leone",
		"isoCode": "SL",
		"dialingCode": "232",
	},
	{
		"countryName": "Singapore",
		"isoCode": "SG",
		"dialingCode": "65",
	},
	{
		"countryName": "Sint Maarten",
		"isoCode": "SX",
		"dialingCode": "1",
	},
	{
		"countryName": "Slovakia",
		"isoCode": "SK",
		"dialingCode": "421",
	},
	{
		"countryName": "Slovenia",
		"isoCode": "SI",
		"dialingCode": "386",
	},
	{
		"countryName": "Solomon Islands",
		"isoCode": "SB",
		"dialingCode": "677",
	},
	{
		"countryName": "Somalia",
		"isoCode": "SO",
		"dialingCode": "252",
	},
	{
		"countryName": "South Africa",
		"isoCode": "ZA",
		"dialingCode": "27",
	},
	{
		"countryName": "South Korea",
		"isoCode": "KR",
		"dialingCode": "82",
	},
	{
		"countryName": "South Sudan",
		"isoCode": "SS",
		"dialingCode": "211",
	},
	{
		"countryName": "Spain",
		"isoCode": "ES",
		"dialingCode": "34",
	},
	{
		"countryName": "Sri Lanka",
		"isoCode": "LK",
		"dialingCode": "94",
	},
	{
		"countryName": "Saint Helena",
		"isoCode": "SH",
		"dialingCode": "290",
	},
	{
		"countryName": "Saint Kitts and Nevis",
		"isoCode": "KN",
		"dialingCode": "1",
	},
	{
		"countryName": "Saint Lucia",
		"isoCode": "LC",
		"dialingCode": "1",
	},
	{
		"countryName": "Saint Martin",
		"isoCode": "MF",
		"dialingCode": "590",
	},
	{
		"countryName": "Saint Pierre and Miquelon",
		"isoCode": "PM",
		"dialingCode": "508",
	},
	{
		"countryName": "Saint Vincent and the Grenadines",
		"isoCode": "VC",
		"dialingCode": "1",
	},
	{
		"countryName": "Sudan",
		"isoCode": "SD",
		"dialingCode": "249",
	},
	{
		"countryName": "Suriname",
		"isoCode": "SR",
		"dialingCode": "597",
	},
	{
		"countryName": "Svalbard and Jan Mayen",
		"isoCode": "SJ",
		"dialingCode": "47",
	},
	{
		"countryName": "Swaziland",
		"isoCode": "SZ",
		"dialingCode": "268",
	},
	{
		"countryName": "Sweden",
		"isoCode": "SE",
		"dialingCode": "46",
	},
	{
		"countryName": "Switzerland",
		"isoCode": "CH",
		"dialingCode": "41",
	},
	{
		"countryName": "Syria",
		"isoCode": "SY",
		"dialingCode": "963",
	},
	{
		"countryName": "Taiwan",
		"isoCode": "TW",
		"dialingCode": "886",
	},
	{
		"countryName": "Tajikistan",
		"isoCode": "TJ",
		"dialingCode": "992",
	},
	{
		"countryName": "Tanzania",
		"isoCode": "TZ",
		"dialingCode": "255",
	},
	{
		"countryName": "Thailand",
		"isoCode": "TH",
		"dialingCode": "66",
	},
	{
		"countryName": "Togo",
		"isoCode": "TG",
		"dialingCode": "228",
	},
	{
		"countryName": "Tokelau",
		"isoCode": "TK",
		"dialingCode": "690",
	},
	{
		"countryName": "Tonga",
		"isoCode": "TO",
		"dialingCode": "676",
	},
	{
		"countryName": "Trinidad and Tobago",
		"isoCode": "TT",
		"dialingCode": "1",
	},
	{
		"countryName": "Tunisia",
		"isoCode": "TN",
		"dialingCode": "216",
	},
	{
		"countryName": "Turkey",
		"isoCode": "TR",
		"dialingCode": "90",
	},
	{
		"countryName": "Turkmenistan",
		"isoCode": "TM",
		"dialingCode": "993",
	},
	{
		"countryName": "Turks and Caicos Islands",
		"isoCode": "TC",
		"dialingCode": "1",
	},
	{
		"countryName": "Tuvalu",
		"isoCode": "TV",
		"dialingCode": "688",
	},
	{
		"countryName": "United Arab Emirates",
		"isoCode": "AE",
		"dialingCode": "971",
	},
	{
		"countryName": "Uganda",
		"isoCode": "UG",
		"dialingCode": "256",
	},
	{
		"countryName": "United Kingdom",
		"isoCode": "GB",
		"dialingCode": "44",
	},
	{
		"countryName": "Ukraine",
		"isoCode": "UA",
		"dialingCode": "380",
	},
	{
		"countryName": "Uruguay",
		"isoCode": "UY",
		"dialingCode": "598",
	},
	{
		"countryName": "United States",
		"isoCode": "US",
		"dialingCode": "1",
	},
	{
		"countryName": "Uzbekistan",
		"isoCode": "UZ",
		"dialingCode": "998",
	},
	{
		"countryName": "Vanuatu",
		"isoCode": "VU",
		"dialingCode": "678",
	},
	{
		"countryName": "Vatican",
		"isoCode": "VA",
		"dialingCode": "379",
	},
	{
		"countryName": "Venezuela",
		"isoCode": "VE",
		"dialingCode": "58",
	},
	{
		"countryName": "Vietnam",
		"isoCode": "VN",
		"dialingCode": "84",
	},
	{
		"countryName": "U.S. Virgin Islands",
		"isoCode": "VI",
		"dialingCode": "1",
	},
	{
		"countryName": "Wallis and Futuna",
		"isoCode": "WF",
		"dialingCode": "681",
	},
	{
		"countryName": "Western Sahara",
		"isoCode": "EH",
		"dialingCode": "212",
	},
	{
		"countryName": "Yemen",
		"isoCode": "YE",
		"dialingCode": "967",
	},
	{
		"countryName": "Zambia",
		"isoCode": "ZM",
		"dialingCode": "260",
	},
	{
		"countryName": "Zimbabwe",
		"isoCode": "ZW",
		"dialingCode": "263",
	},
];



// WEBPACK FOOTER //
// ./src/shared/dictionaries/countryDialingCodes.js